export default __webpack_public_path__ + "static/media/fridge1-after2-2048w.55000cb2.webp";